const facultyList = {
  A: 'Arts',
  B: 'Business and Economics',
  C: 'Information Technology',
  D: 'Education',
  E: 'Engineering',
  F: 'MADA (Art, Design and Architecture)',
  L: 'Law',
  M: 'MNHS (Medicine, Nursing and Health Sciences)',
  P: 'Pharmacy and Pharmaceutical Sciences',
  S: 'Science',
};

const getFacultyfromCode = (code) => {
  return facultyList[code?.slice(0, 1)] || 'Other';
};

export default getFacultyfromCode;
